
export const zh: { [key: string]: { [key: string]: string } } = {
    common: {
        register: "Registro",
        login: "Entrar"
    },
    downloadPlatform: {
        title: "选择安装方式",
        pwa: "安装 PWA",
        apk: "下载 APK",
        pwaNotSupported: "此浏览器不支持安装",
        footer: "请选择您想要的安装方式"
    }
};
